import Login from './Login';
import PhoneNumberInput from 'views/MFA/PhoneNumberInput/PhoneNumberInput';
import ResetMFA from 'views/MFA/ResetMFA/ResetMFA';
import React, { useState } from 'react';
import VerificationCode from 'views/MFA/CodeVerification/VerificationCode';
import axios from 'axios';
import firebase from 'firebase/compat/app';
import 'firebase/compat/auth';

function LoginMFA() {
  const [resolver, setResolver] = useState(null);
  const [userCredentials, setUserCredentials] = useState(null);
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [verificationId, setVerificationId] = useState('');
  const [phoneNumber, setPhoneNumber] = useState('');
  const [resetMFA, setResetMFA] = useState(false);

  if (!resolver && !userCredentials) {
    return (
      <Login
        setResolver={setResolver}
        setUserCredentials={setUserCredentials}
        setEmail={setEmail}
        setPassword={setPassword}
      />
    );
  }

  if (resetMFA) {
    return <ResetMFA email={email} password={password} resolver={resolver} />;
  }

  if (verificationId === '') {
    const fixEmailVerification = async () => {
      const userId = firebase.auth().currentUser?.uid;
      await axios.post(
        'https://us-central1-o-neill-marketing-portal.cloudfunctions.net/forceEmailVerify',
        { uid: userId }
      );
    };

    fixEmailVerification();

    return (
      <PhoneNumberInput
        resolver={resolver}
        setVerificationId={setVerificationId}
        setPhoneNumber={setPhoneNumber}
        setResetMFA={setResetMFA}
      />
    );
  }

  return (
    <VerificationCode
      resolver={resolver}
      userCredentials={userCredentials}
      verificationId={verificationId}
      setVerificationId={setVerificationId}
      phoneNumber={phoneNumber}
      setUserCredentials={setUserCredentials}
      reloadPortal
    />
  );
}

export default LoginMFA;
